export default "__VITE_ASSET__31366812__"